import {
  initialState,
  Actions,
  State,
  DUPLICATE_SESSION,
  DUPLICATE_SESSION_SUCCESS,
  DUPLICATE_SESSION_ERROR,
  RESET_DUPLICATE_SESSION,
} from "../../types/session/duplicate";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case DUPLICATE_SESSION:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case DUPLICATE_SESSION_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case DUPLICATE_SESSION_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: false,
          error: action.payload,
          success: false,
        },
      };
    case RESET_DUPLICATE_SESSION:
      return initialState;
    default:
      return state;
  }
};

export default reducers;
